module.exports = __webpack_public_path__ + "media/Room2DoorPassword.99bd3a4c.mp3";